window.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

if (params.get('contact_posted') === 'true') {
  const elements = document.querySelectorAll(
    '#QuoteForm, .x-variant-picker, .x-block-custom-options, .x-block-buy-buttons'
  );

  elements.forEach(el => {
    el.style.visibility = 'hidden';
  });

  setTimeout(() => {
    elements.forEach(el => {
      el.style.display = 'none';
    });

    const successEl = document.querySelector('.custom-product-template');

    if (successEl) {
      successEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

  }, 500);
}
  else{
    const form = document.querySelector('.custom-form-success');
    if (form) {
        form.style.display = 'none';
    }
  }
    const selected_opt_8 = document.querySelector('input[name^="Oven Size"]:checked');
    let deliveryPrice_text = 0;

    if (selected_opt_8.value.trim() === "Fiamma 65") {
      deliveryPrice_text = 630.00;
    } 
    else if (selected_opt_8.value.trim() === 'Fiamma 80') {
      deliveryPrice_text = 730.00;
    } 


    // Format price properly


      // Update radios safely
      // document.querySelectorAll('input[name="Delivery"]').forEach(radio => {
      //   if (radio.value.includes('Shipping (contiguous U.S.)')) {
          
          const formattedPrice = deliveryPrice_text.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          });

          const newText = `<b>🚚 Flat-rate shipping:</b> ${formattedPrice_delivery} <small>(Added on Checkout)</small>`;

          // Update input value (for form submission)
          const shippingprice = document.querySelector('.shipping-price-text');
          shippingprice.innerHTML = newText;

          // Update label text (for UI)
          // const label = document.querySelector(`label[for="${radio.id}"]`);
          // if (label) {
          //   label.textContent = newText;
          // }
      //   }
      // });

});

const requiredFields = document.querySelectorAll('[required]');

function validateRequiredField(field) {
  const value = field.value.trim();
  if (!value) {
    field.classList.add('custom-field-error');
    return false; // Field is invalid
  } else {
    field.classList.remove('custom-field-error');
    return true; // Field is valid
  }
}

requiredFields.forEach(field => {
  field.addEventListener('blur', () => validateRequiredField(field));

  field.addEventListener('input', () => {
    if (field.value.trim()) {
      field.classList.remove('custom-field-error');
    }
  });
});

const originalFetch = window.fetch;



// window.fetch = function (...args) {
//   if (typeof args[0] === 'string' && args[0].includes('/cart/add')) {
    
//     // --- 1. FORCE VALIDATION ---
//     // We check all fields now, otherwise 'errorFields' might be empty 
//     // if the user never touched the inputs.
//     requiredFields.forEach(field => validateRequiredField(field));

//     // --- 2. CHECK FOR ERRORS ---
//     const errorFields = document.querySelectorAll('.custom-field-error');
    
//     if (errorFields.length > 0) {
//       // SCROLL TO FIRST ERROR
//       const first = errorFields[0];
//       const yOffset = -120; // Extra padding so the field isn't tucked under a header
//       const y = first.getBoundingClientRect().top + window.pageYOffset + yOffset;

//       window.scrollTo({
//         top: y,
//         behavior: 'smooth'
//       });

//       first.focus(); // Focus the field so user can type immediately
//       return Promise.reject('Blocked add to cart: Missing required fields');
//     }

//     // --- 3. PRICE CALCULATION LOGIC ---
  

//     // --- 4. FINAL SUBMISSION ---
//     document.querySelector('#QuoteForm')?.submit();
//     return Promise.reject('Redirecting to Quote Form');
//   }

//   return originalFetch.apply(this, args);
// };


// const hiddenInput_3 = document.getElementById('ContactFormChimney');
// const hiddenInput_4 = document.getElementById('ContactFormFuelType');
// const hiddenInput_5 = document.getElementById('ContactFormPrice');
// const hiddenInput_6 = document.getElementById('ContactFormPizza');
// const hiddenInput_7 = document.getElementById('ContactFormDelivery');
// const hiddenInput_8 = document.getElementById('ContactFormVariant');

function syncColor() {
  const selected_opt_3 = document.querySelector('input[name^="Stainless Steel Double Wall Chimney with Cup-1"]:checked');
  const selected_opt_4 = document.querySelector('input[name^="Fuel Type"]:checked');
  const selected_opt_5 = document.querySelector('.main-product-price .price');
  const selected_opt_6 = document.querySelector('input[name^="Pizza Peel"]:checked');
  const selected_opt_7 = document.querySelector('input[name^="Delivery"]:checked');
  const selected_opt_8 = document.querySelector('input[name^="Oven Size"]:checked');

//   if (selected_opt_3) hiddenInput_3.value = selected_opt_3.value;
//   if (selected_opt_4) hiddenInput_4.value = selected_opt_4.value;
  let pizzaPeelPrice = 0;
      let deliveryPrice = 0;
      let basePrice = 0;
      if (selected_opt_6) {
    //   hiddenInput_6.value = selected_opt_6.value;
        const value = selected_opt_6.value;

        // Extract number after $
        const match = value.match(/\$(\d+(?:\.\d+)?)/);

        if (match) {
          pizzaPeelPrice = parseFloat(match[1]);
        }
      }
      if (selected_opt_7) {
    //   hiddenInput_7.value = selected_opt_7.value;
        const value = selected_opt_7.value;
        // Extract number after $
        const match = value.match(/\$(\d+(?:\.\d+)?)/);
        if (match) {
          deliveryPrice = parseFloat(match[1]);
          if (deliveryPrice !== null && deliveryPrice !== undefined) {
            if (selected_opt_8.value.trim() === "Fiamma 65" && deliveryPrice != 0) {
             deliveryPrice = 630;
            }
            else if (selected_opt_8.value.trim() === "Fiamma 80" && deliveryPrice != 0) {
             deliveryPrice = 730;
            } 
          }
        }
      }
      if (selected_opt_5) {
        const text = selected_opt_5.textContent.trim();
        const match = text.match(/\$([\d,]+(?:\.\d+)?)/);
        // extract number from string (e.g. "$1200")

        if (match) {
          basePrice = parseFloat(match[1].replace(/,/g, ''));
        }
      }
        if(selected_opt_8){
        // hiddenInput_8.value = selected_opt_8.value;
        let deliveryPrice_text = 0;
        if (selected_opt_8.value.trim() === "Fiamma 65") {
          deliveryPrice_text = 630.00;
        } 
        else if (selected_opt_8.value.trim() === 'Fiamma 80') {
          deliveryPrice_text = 730.00;
        }
        console.log(deliveryPrice_text);


        // Update radios safely
        // document.querySelectorAll('input[name="Delivery"]').forEach(radio => {
        //   if (radio.value.includes('Shipping (contiguous U.S.)')) {
            
            const formattedPrice_delivery = deliveryPrice_text.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD'
            });

            const newText = `<b>🚚 Flat-rate shipping:</b> ${formattedPrice_delivery} <small>(Added on Checkout)</small>`;

            // Update input value (for form submission)
            const shippingprice = document.querySelector('.shipping-price-text');
            shippingprice.innerHTML = newText;

            // Update label text (for UI)
            // const label = document.querySelector(`label[for="${radio.id}"]`);
            // if (label) {
            //   label.textContent = newText;
            // }
        //   }
        // });
      }

      let chimney_price = 0;
      let chimney_type = selected_opt_3.value;
      if (selected_opt_8.value.trim() === "Fiamma 65"){
        basePrice = 7900;
      }
      if (chimney_type === "Not Needed" && selected_opt_8.value.trim() === "Fiamma 65" ) {
        document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46373268848811; }); 
      }
      if (chimney_type === "Yes We Need The Chimney" && selected_opt_8.value.trim() === "Fiamma 65" ) {
        chimney_price = 470;
        document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46373268881579; }); 
      }

      if (selected_opt_8.value.trim() === "Fiamma 80"){
        basePrice = 9900;
      }
      if (chimney_type === "Not Needed" && selected_opt_8.value.trim() === "Fiamma 80" ) {
        document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46388084015275; }); 
      }
      if (chimney_type === "Yes We Need The Chimney" && selected_opt_8.value.trim() === "Fiamma 80" ) {
        chimney_price = 570;
        document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46388084048043; }); 
      }

      const totalPrice = Math.round(basePrice + chimney_price + pizzaPeelPrice + deliveryPrice);
      const formattedPrice = `$${totalPrice.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    //   hiddenInput_5.value = formattedPrice;
      updateAllCustomPrices(formattedPrice);

      }
      function updateAllCustomPrices(formattedPrice) {
        const elements = document.querySelectorAll('.custom-price');

        elements.forEach(el => {
          el.textContent = formattedPrice;
        });
      }
      let syncTimer = null;

      function runSyncBurst() {
        let elapsed = 0;

        clearInterval(syncTimer); // IMPORTANT: prevent stacking

        syncTimer = setInterval(() => {
          syncColor();

          elapsed += 300;

          if (elapsed >= 2000) {
            clearInterval(syncTimer);
            syncTimer = null;
          }
        }, 300);
      }
      document.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) {
          runSyncBurst();
        }
      });

document.addEventListener('DOMContentLoaded', () => {
  runSyncBurst();
});


const phoneInput = document.getElementById('Product-Quote-Form-Phone-Number');

phoneInput.addEventListener('input', (e) => {
  let x = e.target.value.replace(/\D/g, '').slice(0, 10);

  let formatted = x;
  if (x.length > 6) {
    formatted = `(${x.slice(0,3)}) ${x.slice(3,6)}-${x.slice(6)}`;
  } else if (x.length > 3) {
    formatted = `(${x.slice(0,3)}) ${x.slice(3)}`;
  }

  e.target.value = formatted;
});